import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const zfVulnerabilitiesPlugin = createPlugin({
  id: 'zf-vulnerabilities',
  routes: {
    root: rootRouteRef,
  },
});

export const ZfVulnerabilitiesPage = zfVulnerabilitiesPlugin.provide(
  createRoutableExtension({
    name: 'ZfVulnerabilitiesPage',
    component: () =>
      import('./components/VulnerabilitiesComponent').then(
        m => m.VulnerabilitiesComponent,
      ),
    mountPoint: rootRouteRef,
  }),
);
